(function () {
  'use strict';

  window.BBJT_AWAKENING_CONFIG = {
    version: 'cinematic-intro-sprint-2',
    readinessTimeoutMs: 1800,
    videoStartSeconds: 1.45,
    storageKey: 'bbjt-awakening-complete',
    mobileMediaQuery: '(max-width: 767px)',
    events: {
      cue: 'bbjt:awakening:cue',
      audioCue: 'bbjt:awakening:audio-cue',
      complete: 'bbjt:awakening:complete'
    },
    timeline: {
      full: window.BBJT_AWAKENING_TIMELINE || [],
      reduced: [
        {
          name: 'black',
          at: 0,
          state: 'commit',
          frame: 'black',
          effect: 'still',
          announce: 'Beats By JT introduction started.'
        },
        {
          name: 'padIllumination',
          at: 100,
          state: 'commit',
          frame: 'pad',
          effect: 'still',
          audioHook: 'padLights'
        },
        {
          name: 'handEntrance',
          at: 700,
          state: 'awakening',
          frame: 'hands',
          effect: 'still'
        },
        {
          name: 'fingerHover',
          at: 1400,
          state: 'impact',
          frame: 'finger_hover',
          effect: 'still'
        },
        {
          name: 'fingerStrike',
          at: 2100,
          state: 'strike',
          frame: 'finger_strike',
          effect: 'still',
          audioHook: 'fingerStrike'
        },
        {
          name: 'truthOne',
          at: 2700,
          state: 'truth',
          frame: 'silence',
          truthStep: 'one',
          effect: 'still',
          announce: 'Some moments entertain'
        },
        {
          name: 'truthOneClear',
          at: 4100,
          state: 'truth',
          frame: 'silence',
          effect: 'still'
        },
        {
          name: 'truthTwo',
          at: 4350,
          state: 'truth',
          frame: 'silence',
          truthStep: 'two',
          effect: 'still',
          announce: 'Some change what comes next'
        },
        {
          name: 'truthTwoClear',
          at: 5750,
          state: 'truth',
          frame: 'silence',
          effect: 'still'
        },
        {
          name: 'truthThree',
          at: 6000,
          state: 'truth',
          frame: 'silence',
          truthStep: 'three',
          effect: 'still',
          announce: 'This is the future'
        },
        {
          name: 'truthThreeClear',
          at: 7650,
          state: 'truth',
          frame: 'silence',
          effect: 'still'
        },
        {
          name: 'logoReveal',
          at: 7850,
          state: 'identity',
          frame: 'logo',
          effect: 'settled',
          announce: 'Beats By JT revealed.'
        },
        {
          name: 'navigationUnlock',
          at: 8850,
          state: 'navigation',
          frame: 'logo',
          effect: 'settled',
          announce: 'Beats By JT revealed. Navigation is now available.'
        }
      ]
    }
  };
})();
